export default "__VITE_ASSET__D0mGrau9__"